<style >
     @media all and (device-width: 768px) and (device-height: 1024px) and (orientation:portrait) {
        #ipad { 
            position:absolute;  width:100%; height:43%; background-color:#172b4e; z-index:10; margin-top:-10px;
        } 
     }
     @media all and (device-width: 1024px) and (device-height: 1366px) and (orientation:portrait) {
        #ipad { 
            position:absolute;  width:100%; height:63%; background-color:#172b4e; z-index:10; margin-top:-10px;
        } 
     }
      @media all and (device-width: 1366px) and (device-height: 1024px) and (orientation: landscape) {
        #ipad { 
            position:absolute;  width:100%; height:43%; background-color:#172b4e; z-index:10; margin-top:-10px;
        }
    }

</style>
<template>
    
    <div class="main-content bg-default">
        
        <!-- Navbar -->
        <base-nav class="navbar-top navbar-horizontal navbar-dark"
                  containerClasses="px-4 container"
                  expand>
<!--             <router-link slot="brand" class="navbar-brand" to="/">
                <img src="img/brand/justwash.png"/>
            </router-link> -->

            <template v-slot="{closeMenu}">
                <!-- Collapse header -->
                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link to="/">
                                <img src="img/brand/justwash.png">
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <button type="button"
                                    @click="closeMenu"
                                    class="navbar-toggler"
                                    aria-label="Toggle sidenav">
                                <span></span>
                                <span></span>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- Navbar items -->
                <ul class="navbar-nav ml-auto">
                    <!-- <li class="nav-item">
                        <router-link class="nav-link nav-link-icon" to="/">
                            <i class="ni ni-planet"></i>
                            <span class="nav-link-inner--text">แดชบอร์ด</span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link nav-link-icon" to="/register">
                            <i class="ni ni-circle-08"></i>
                            <span class="nav-link-inner--text">สมัครสมาชิก</span>
                        </router-link>
                    </li> -->
                    <li class="nav-item">
                        <router-link class="nav-link nav-link-icon" to="/login">
                            <i class="ni ni-key-25"></i>
                            <span class="nav-link-inner--text">เข้าสู่ระบบ</span>
                        </router-link>
                    </li>
                    <!-- <li class="nav-item">
                        <router-link class="nav-link nav-link-icon" to="/profile">
                            <i class="ni ni-single-02"></i>
                            <span class="nav-link-inner--text">ข้อมูลส่วนตัว</span>
                        </router-link>
                    </li> -->
                </ul>
            </template>
        </base-nav>
        <!-- Header -->
        <div class="header  py-7 py-lg-8">
            <div class="container">
                <div class="header-body text-center mb-7">
                    <div class="row justify-content-center">
                        <div class="col-lg-5 col-md-6">
                            <!-- <h1 class="text-white">ยินดีต้อนรับ!</h1>
                            <p class="text-lead text-white">เข้าสู่ระบบหรือสร้างบัญชีใหม่ของคุณได้ฟรี</p> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
                     xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div>
        </div>
        <!-- Page content -->
        <div class="container mt--8 pb-5">
            <slide-y-up-transition mode="out-in" origin="center top">
                <router-view></router-view>
            </slide-y-up-transition>
        </div>
        <footer class="py-5">
            <div class="container">
                <div class="row align-items-center justify-content-xl-between">
                    <div class="col-xl-6">
                        <div class="copyright text-center text-xl-left text-muted">
                            <!-- &copy; {{year}} <a href="https://www.creative-tim.com" class="font-weight-bold ml-1"
                                               target="_blank">Creative Tim</a> -->
                            Copyright © by<a href="https://justwash.asia" class="font-weight-bold ml-1"
                                              target="_blank">Justwash</a>. All rights reserved.
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <ul class="nav nav-footer justify-content-center justify-content-xl-end">
                            <!-- <li class="nav-item">
                                <a href="https://www.creative-tim.com" class="nav-link" target="_blank">Creative Tim</a>
                            </li> -->
                            <li class="nav-item">
                                <!-- <a href="https://justwash.asia" class="nav-link" target="_blank">เกี่ยวกับเรา</a> -->
                            </li>
                            <li class="nav-item">
                                <!-- <a href="http://justwash.asia/blog" class="nav-link" target="_blank">บทความ</a> -->
                            </li>
                            <!-- <li class="nav-item">
                                <a href="https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md"
                                   class="nav-link" target="_blank">MIT License</a>
                            </li> -->
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    <div id="ipad">
           
    </div>
    </div>
    
</template>
<script>
  import { SlideYUpTransition } from 'vue2-transitions'

  export default {
    name: 'auth-layout',
    components: {
      SlideYUpTransition
    },
    data() {
      return {
        year: new Date().getFullYear(),
        showMenu: false
      }
    }
  }
</script>
<style>
</style>
